export const PROGRAM_FRIENDLY_MAPPING = {
  '10': 'Assistance to Firefighters Grants',
  '11': 'Staffing for Adequate Fire and Emergency Response (SAFER)',
  '12': 'Fire Prevention and Safety',
  '13': 'Pre-Disaster Mitigation',
  '14': 'Flood Mitigation Assistance',
  '15': 'Building Resilient Infrastructure and Communities',
  '16': 'Hazard Mitigation Grant Program',
  '17': 'Hazard Mitigation Grant Program Post Fire',
  '18': 'Disaster Case Management',
  '19': 'Port Security Grant Program',
  '20': 'Community Assistance Program-State Support Services Element',
  '21':
    'Homeland Security National Training Program (HSNTP) Continuing Training Grants (CTG)',
  '22': 'Cooperating Technical Partners',
  '23': 'Emergency Management Baseline Assessment Grant',
  '24': 'Intercity Bus Security Grant Program',
  '25': 'Transit Security Grant Program',
  '26': 'Intercity Passenger Rail Program',
  '27':
    'Homeland Security National Training Program National Domestic Preparedness Consortium',
  '28': 'FEMA NEHRP State Assistance Grant Program',
  '29': 'Presidential Residence Protection Assistance Grant Program',
  '30': 'Tribal Homeland Security Grant Program',
  '31': 'National Dam Safety Program',
  '32': 'Urban Search and Rescue',
  '33': 'Targeted Violence and Terrorism Prevention Grant Program',
  '34': 'Emergency Operations Center',
  '35': 'Emergency Food and Shelter National Board Program',
  '36': 'Homeland Security Preparedness Technical Assistance Program',
  '37': 'Program to Prepare Communities for Complex Coordinated Terrorist Attacks',
  '38': 'National Incident Management System',
  '39': 'National Incident Management System',
  '40': 'State Fire Training System Grant',
  '41': 'Safeguarding Tomorrow RLF',
  '42': 'Emergency Management Performance Grant',
  '43': 'Homeland Security Grant Program',
  '44': 'Nonprofit Security Grant Program',
  '45': 'NDSP Rehabilitation of High Hazard Potential Dams (HHPD) Program',
  '46': 'Generic Grants Program',
  '47': 'FEMA Fire Management Assistance Grant Program',
  '48': 'FEMA Public Assistance Grant Program',
  '49': 'Shelter and Services Program',
  '50': 'Case Management Pilot Program',
  '51': 'Next Generation Warning System Grant Program',
  '52': 'State and Local Cybersecurity Grant Program',
  '53': 'Tribal Cybersecurity Grant Program',
  '54': 'Flood Mitigation Assistance Swift Current',
  '55': 'Detention Support Grant Program',
  '56': 'Unmanned Aircraft Systems Detection Grant Program',
  '57': 'State Border Security Reinforcement Fund',
  '58': 'FIFA World Cup Grant Program',
  '59': 'Counter-Unmanned Aircraft Systems Grant Program',
  '60': 'Operation Stonegarden Plus Test',
  '61': 'BioWatch Grant Program',
  '79': 'Olympic and Paralympic Games Grant Program'
};

export const getProgramNamesFromPermissions = (permissions) => {
  const programNames = new Set();

  for (const perm of permissions) {
    const programName = extractProgramNameFromPermission(perm);

    if (programName) {
      programNames.add(programName);
    }
  }

  return Array.from(programNames);
};

const extractProgramNameFromPermission = (permission) => {
  const permissionSplit = permission.split(':');
  if (permissionSplit.length > 1) {
    const entityId = permissionSplit[1];
    const programIdToFind = obtainProgramIdFromEntity(entityId);
    if (programIdToFind && programIdToFind in PROGRAM_FRIENDLY_MAPPING) {
      return PROGRAM_FRIENDLY_MAPPING[programIdToFind];
    }
  }

  return '';
};

const obtainProgramIdFromEntity = (entityId) => {
  const entitySplit = entityId.split('_');

  switch (entitySplit.length) {
    case 1:
      return null;
    default:
      return entitySplit[1];
  }
};
